import controller from './kform.controller';
import template from './kform.html';

export default {
	template,
	bindings:     {
		create:         '<',
		files:          '=?',
		forms:          '=?',
		kid:            '<',
		loading:        '=?',
		name:           '=',
		onBeforeSubmit: '&?',
		onCancel:       '&?',
		onSubmit:       '&?',
		options:        '<?',
		row:            '<?',
		submissions:    '=?',
		tab:            '<?',
	},
	controller,
	controllerAs: '$ctrl',
};
